import { render, staticRenderFns } from "./Quickfind.vue?vue&type=template&id=52a01638&scoped=true&"
import script from "./Quickfind.vue?vue&type=script&lang=js&"
export * from "./Quickfind.vue?vue&type=script&lang=js&"
import style0 from "./Quickfind.vue?vue&type=style&index=0&id=52a01638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a01638",
  null
  
)

export default component.exports